import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { GridInteractionProvider } from './context/GridInteractionContext';
import { BusinessTimezoneProvider } from './context/BusinessTimezoneProvider';
import ProtectedRoute from './components/ProtectedRoute';
import AuthenticatedAppShell from './components/AuthenticatedAppShell';
import PageLoader from './components/PageLoader';
import Login from './pages/Login';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Repair = lazy(() => import('./modules/fleetRepair/RepairPage'));
const DriverSchedule = lazy(() => import('./pages/DriverSchedule'));
const Trucks = lazy(() => import('./pages/Trucks'));
const Drivers = lazy(() => import('./pages/Drivers'));
const DriverImportReview = lazy(() => import('./pages/DriverImportReview'));
const DriversAvailability = lazy(() => import('./pages/DriversAvailability'));
const TruckSchedulePage = lazy(() => import('./pages/TruckSchedule'));
const AvailabilityLinkPage = lazy(() => import('./pages/public/AvailabilityLinkPage'));
const CampaignAvailabilityPage = lazy(() => import('./pages/public/CampaignAvailabilityPage'));
const AvailabilityLinkInvalidPage = lazy(() => import('./pages/public/AvailabilityLinkInvalidPage'));
const SendDriverSchedulePage = lazy(() => import('./modules/sendDriverSchedule/SendDriverSchedulePage'));
const SendTruckSchedulePage = lazy(() => import('./modules/sendTruckSchedule/SendTruckSchedulePage'));
const ScheduleWriteEvidence = lazy(() => import('./pages/ScheduleWriteEvidence'));

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/a/c/:token" element={<CampaignAvailabilityPage />} />
              <Route path="/a/:token" element={<AvailabilityLinkPage />} />
              <Route path="/form/*" element={<AvailabilityLinkInvalidPage />} />
              <Route path="/login" element={<Login />} />
              <Route
                element={
                  <ProtectedRoute>
                    <AuthenticatedAppShell />
                  </ProtectedRoute>
                }
              >
                <Route
                  path="/dashboard"
                  element={<Dashboard />}
                />
                <Route path="/maintenance" element={<Navigate to="/repair" replace />} />
                <Route path="/repair" element={<Repair />} />
                <Route
                  path="/driver-schedule"
                  element={
                    <GridInteractionProvider>
                      <BusinessTimezoneProvider>
                        <DriverSchedule />
                      </BusinessTimezoneProvider>
                    </GridInteractionProvider>
                  }
                />
                <Route
                  path="/trucks"
                  element={<Trucks />}
                />
                <Route
                  path="/drivers"
                  element={<Drivers />}
                />
                <Route
                  path="/drivers/import-review/:sessionId"
                  element={<DriverImportReview />}
                />
                <Route
                  path="/drivers-availability"
                  element={<DriversAvailability />}
                />
                <Route
                  path="/truck-schedule"
                  element={<TruckSchedulePage />}
                />
                <Route path="/send-driver-schedule" element={<SendDriverSchedulePage />} />
                <Route path="/send-truck-schedule" element={<SendTruckSchedulePage />} />
                <Route path="/admin/schedule-write-evidence" element={<ScheduleWriteEvidence />} />
              </Route>
              <Route
                path="/"
                element={
                  <Navigate to="/dashboard" replace />
                }
              />
            </Routes>
          </Suspense>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
